import { createProgram, createShader } from './webgl-helper'
import shapeVert from './shaders/shape.vert'
import shapeFrag from './shaders/shape.frag'
import imgVert from './shaders/img.vert'
import imgFrag from './shaders/img.frag'
import slidesVert from './shaders/slides.vert'
import slidesFrag from './shaders/slides.frag'
import blurImgVert from './shaders/blurImg.vert'
import blurImgFrag from './shaders/blurImg.frag'

export function getPrograms(gl) {
	const shapeProgram = createProgram(
		gl,
		createShader(gl, gl.VERTEX_SHADER, shapeVert),
		createShader(gl, gl.FRAGMENT_SHADER, shapeFrag),
	)

	const imgProgram = createProgram(
		gl,
		createShader(gl, gl.VERTEX_SHADER, imgVert),
		createShader(gl, gl.FRAGMENT_SHADER, imgFrag),
	)

	const slidesProgram = createProgram(
		gl,
		createShader(gl, gl.VERTEX_SHADER, slidesVert),
		createShader(gl, gl.FRAGMENT_SHADER, slidesFrag),
	)

	const blurImgProgram = createProgram(
		gl,
		createShader(gl, gl.VERTEX_SHADER, blurImgVert),
		createShader(gl, gl.FRAGMENT_SHADER, blurImgFrag),
	)

	return {
		shapeProgram,
		imgProgram,
		slidesProgram,
		blurImgProgram,
	}
}
